var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version2-top-bottom"},[_c('Header',{attrs:{"title":"专利运营转化"}}),_c('Pie',{staticClass:"echartsBlock",attrs:{"options":_vm.options},on:{"echartClick":_vm.echartClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }